export default __webpack_public_path__ + "static/media/nonabs.ebab4321.jpg";